import React from "react";

export default class Checkbox extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isChecked: props.checked != undefined ? props.checked : false
      };
    }
    toggleChange = () => {

      var val = !this.state.isChecked;
      this.setState({
        isChecked: val,
      });
      this.props.onElementCheck(val);
    }
    render() {
      return (
          <input type="checkbox"
            defaultChecked={this.state.isChecked}
            onChange={this.toggleChange}
          />
      );
    }
  
}

const mainClass = {
    padding: '10px',
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}